import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectPackages, selectActivePlacingType } from '../../../../../../../selectors/publishTerms';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../../../selectors/analytics';
import { selectPlacingType, selectPackage, EPlacingType } from '../../../../../../../redux/reducers';
import { trackPackageSelect } from '../../Packages/tracking';

import { formatPackageOptionLabel } from './utils';

export const useSinglePackage = () => {
  const dispatch = useDispatch();

  const [servicePackage] = useSelector(selectPackages);
  const activePlacingType = useSelector(selectActivePlacingType);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);

  const label = formatPackageOptionLabel(servicePackage);
  const checked = activePlacingType === EPlacingType.package;

  const handlePackageChange = useCallback(() => {
    if (!checked) {
      trackPackageSelect({ analyticsOfferStatus, analyticsProduct, packageServiceId: servicePackage.serviceId });
      dispatch(selectPackage(servicePackage.id));
    }

    dispatch(selectPlacingType(checked ? EPlacingType.balance : EPlacingType.package));
  }, [dispatch, checked, servicePackage, analyticsOfferStatus, analyticsProduct]);

  return { label, checked, handlePackageChange };
};
